// Base URL of the TraKing API (live). The old dev stage was
// https://q7hxku4ta3.execute-api.ap-south-1.amazonaws.com/Prod — its company ids differ.
export const TRAKING_API_BASE = "https://api.traking.ai";
